import apiClient from "../api/axios";
import { useState } from "react";

export default function useFileUploader() {

  const [uploadStatus,setUploadStatus] = useState('')

  const uploadImage = async (image,path,filename) => {
  
    if (!image) {
      setUploadStatus("Please select an image.");
      return undefined;
    }

    // Ensure filename includes extension
    const ext = image.name.split('.').pop();
    const finalFilename = filename && filename.includes('.') ? filename : `${filename}.${ext}`;

    const formData = new FormData();
    formData.append("image", image);
    formData.append("path", path); // change as needed
    formData.append("filename", finalFilename); // or generate dynamically

    try {
      const response = await apiClient.post("upload-image",formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
      
      
      setUploadStatus(`✅ Uploaded! URL: ${response.data.url}`);
      // Prefer relative path if provided, fall back to absolute URL
      return response.data.path || response.data.url
    } catch (error) {
      setUploadStatus(
        `❌ Upload failed: ${error.response?.data?.message || error.message}`
      );
      return undefined;
    }
  };
  return {
    uploadImage,
    uploadStatus
  };
};
